export default function BusMarker({ vehicle, index, onClick }) {
  return (
    <div
      className="w-20 h-8 absolute cursor-pointer -translate-x-1/2 -translate-y-1/2 p-1 rounded-md text-xs text-white bg-indigo-500 flex items-center justify-center"
      style={{
        top: `${20 + (index * 18) % 80}%`,
        left: `${10 + (index * 23) % 80}%`,
      }}
      onClick={onClick}
      title={`${vehicle.id} • ${vehicle.route}`}
    >
      {vehicle.id}
    </div>
  );
}
